<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div
        v-show="showMainList"
        class="main-content"
        type="primary"
      >
        <!-- <div style="height: auto;width: 100%;margin-top: 5px;" class="cargo-advance-search fcl-search-bar">
          <div class="section cargo-advance-search-more">
            <el-form
              label-position="left"
              class="cargo-advance-search-form"
              :label-width="isZh ? '75px' : '110px'"
              style="min-width: 830px;margin-right: 10px"
              :inline="true"
            >
              <el-form-item :label="$t('SeaExport.BusinessNo')">
                <el-input
                  v-model="filter.jobNo"
                  style="width: 200px"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_AuthorizedClient')">
                <cargo-company-select
                  :method-params="{customer:true,active:true}"
                  :default-value="filter.customerId||''"
                  custom-style="width: 200px"
                  @change="p=>{filter.customerId=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.MasterBillNo')">
                <el-input
                  v-model="filter.mbl"
                  style="width: 200px"
                />
              </el-form-item>
              <el-button style="margin-left: 10px" type="primary" @click="toQuery">
                {{ $t('CargoMsg.Cargo_Query') }}
              </el-button>
            </el-form>
            <el-form
              label-position="left"
              class="cargo-advance-search-form"
              :label-width="isZh ? '75px' : '110px'"
              style="min-width: 830px;margin-right: 10px"
              :inline="true"
            >
              <el-form-item :label="$t('CargoMsg.Cargo_Carrier')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{seaCmp:true}"
                  :custom-label="(item)=>`${item.chineseName}`"
                  :show-custom-label-in-option="true"
                  style="width: 200px"
                  :default-value="filter.carrierId"
                  @parentCallBack="p=>{filter.carrierId=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_BusinessType')">
                <cargo-advance-select
                  :select-type="selectTypeNames.local_cache_SystemConstants$LOBS"
                  :show-custom-label-in-option="true"
                  :default-value="filter.lob"
                  style="width: 200px"
                  @parentCallBack="changeLob"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_FlightVoyage')">
                <el-input
                  v-model="filter.flight"
                  style="width: 200px"
                />
              </el-form-item>
              <el-button style="margin-left: 10px" type="default" @click="batchDowloadHandler">
                {{ $t('CargoMsg.Cargo_BatchDownload') }}
              </el-button>
            </el-form>
            <el-form
              label-position="left"
              class="cargo-advance-search-form"
              :label-width="isZh ? '75px' : '110px'"
              style="min-width: 830px;margin-right: 10px"
              :inline="true"
            >
              <el-form-item :label="$t('CargoMsg.Cargo_FileType')">
                <el-input
                  :value="fileCategoryLabel"
                  style="width: 200px"
                  @click.native="fileTypeEditor.visible=true"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_SailingDate')">
                <el-date-picker
                  v-model="filter.etdMin"
                  type="date"
                  style="width:98px;"
                  value-format="yyyy-MM-dd"
                />
                <el-date-picker
                  v-model="filter.etdMax"
                  type="date"
                  style="width:98px;margin-left:6px"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_BusinessNum')">
                <el-input-number
                  v-model="filter.limit"
                  style="width: 50px"
                  controls-position="left"
                  :controls="false"
                />
              </el-form-item>
              <el-button type="default" style="margin-left: 160px" @click="resetSearch()">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
            </el-form>
          </div>
        </div> -->
        <search-item
          config-module="210102"
          :reset="true"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <el-input
            slot="customType1"
            :value="fileCategoryLabel"
            style="width: 100%"
            @click.native="fileTypeEditor.visible=true"
          />
          <el-input-number
            slot="customType2"
            v-model="pageSize"
            style="width: 100%"
            controls-position="left"
            :controls="false"
          />
          <template slot="operations">
            <el-button type="primary" @click="batchDowloadHandler">{{ $t('CargoMsg.Cargo_BatchDownload') }}</el-button>
          </template>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="42010101"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :deselect-sub-record="true"
          />
        </div>
      </div>
    </div>
    <!-- 文件类型选择对话框 -->
    <mx-file-type-editor
      v-if="fileTypeEditor.visible"
      :visible.sync="fileTypeEditor.visible"
      :lob="searchLob"
      :file-id="fileTypeEditor.fileId"
      :file-category="documentType"
      @saveFileType="changeFileType"
    />
    <div class="pagination-wrapper">
      <div class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="total"
          layout="total"
        />
      </div>
    </div>
    <!-- 用于打开新的报表页面，以post方式提交 -->
    <form ref="downloadForm" :action="submitForm.url" target="_blank" method="post" style="display:none">
      <input v-for="item in submitForm.formEntries" :key="decodeURIComponent(item[0])" :name="decodeURIComponent(item[0])" :value="decodeURIComponent(item[1])">
    </form>
  </div>
</template>

<script>
import { cache, cacheName } from '@/utils/cacheManager'
import { getFileList } from '@/api/storage'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import CargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import MxFileTypeEditor from '@/components/Cargo/Job/mxFileTypeEditor'
import { queryFileHistory, queryJobs } from '@/api/booking/job'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { DocumentTypeUtil } from '@/class/cargo/model/utils/DocumentTypeUtil'
import { sortByMultiFieldAndOrder } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import URL from '@/api/urlTranslator'
import moment from 'moment'
import StrUtils from '@/utils/StrUtils'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'

export default {
  name: 'FileHistory',
  components: { MxFileTypeEditor, CargoAdvanceSelect, CargoCompanySelect, searchItem },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      showDetail: false,
      gridParams: {},
      storageURL: '',
      rowData: [],
      fullscreenLoading: null,
      jobFileSizeMap: null,
      total: 0,
      jobList: [],
      jobMap: {},
      documentType: '',
      fileCategoryLabel: '',
      // filter: {
      //   lob: '',
      //   etdMin: '',
      //   etdMax: '',
      //   documentType: '',
      //   limit: 30,
      //   branchId: 0,
      //   carrierId: 0
      // },
      filter: {
        conditions: [],
        branchId: 0
      },
      pageNum: 1,
      pageSize: 30,
      fileTypeEditor: {
        visible: false,
        fileId: '',
        fileCategory: ''
      },
      creatorOption: null,
      createDateOption: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        getDataPath: data => {
          return (data.path || '').split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              return true
            }
          }
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.onGridRowSelected(event)
        },
        defaultColDef: {
          resizable: true
        },
        onSortChanged: (event) => {
          // this.$logger.log('onSortChanged-event', event)
          if (event && event.api && event.api.rowRenderer) {
            const rowComps = event.api.rowRenderer.rowCompsByIndex
            if (!rowComps) return
            const currentSortJobs = []
            for (const key in rowComps) {
              if (!rowComps[key].rowNode || !rowComps[key].rowNode.data) continue
              currentSortJobs.push(rowComps[key].rowNode.data)
            }
            this.rowData = currentSortJobs
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: 'MBL', field: 'mbl', colId: 'mbl', width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'), field: 'customerId', colId: 'customerId', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, this.language)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Carrier'), field: 'carrierId', colId: 'carrierId', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SailingDate'), field: 'ETD', colId: 'ETD', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'), field: 'loadingPortCode', colId: 'loadingPortCode', width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'), field: 'destinationPortCode', colId: 'destinationPortCode', width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VoyageFlight'), field: 'voyageFlight', colId: 'voyageFlight', width: 100
        },
        {
          headerName: this.$t('SeaExport.Operation'), field: 'op', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, this.language)
          }
        },
        {
          headerName: this.$t('SeaExport.FileName'), field: 'fileName', colId: 'fileName', width: 100
        },
        {
          headerName: this.$t('FileHistory.fileVersion'), field: 'fileVersion', colId: 'fileVersion', width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FileType'), field: 'jobType', colId: 'jobType', width: 100,
          cellRenderer: params => {
            return this.documentTypeUtil.fileTypeLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FileFormat'), field: 'fileType', colId: 'fileType', width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FileSize'), field: 'fileSize', colId: 'fileSize', width: 100,
          cellRenderer: params => {
            return ColumnUtils.fileSizeColumnLabel(params.value)
          }
        },
        {
          headerName: this.$t('FileHistory.FileCreator'), field: 'createdBy', colId: 'createdBy', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, this.language)
          }
        },
        {
          headerName: this.$t('FileHistory.FileCreationDate'), field: 'createDate', width: 150,
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ViewFile'), field: 'documentId', colId: 'documentId', width: 100, noExport: true,
          cellRenderer: params => {
            return StrUtils.isEmpty(params.data.documentId) ? '' : `<a href="${URL.common.findByFileId}/${params.data.documentId || 'null'}?sessionId=${this.user.sessionId}" target="_blank" style="color:#46a6ff">${this.$t('SeaExport.ViewFile')}</a>`
          }
        }
      ],
      submitForm: {
        url: URL.common.downloadCompressFiles,
        formEntries: []
      },
      searchLob: 'allLob'
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.user = cache.user
      this.storageURL = cache.config.get('StorageURL')
      this.documentTypeUtil = await DocumentTypeUtil.getInstance()
    },
    getFileList() {
      if (this.jobList.length === 0) {
        this.total = 0
        return
      }
      const xmlParam =
        '<RequestObject><data><extendMetaData><entry><key>jobNo</key><value>' +
        this.getJobNoKey() + '</value></entry><entry><key>documentType</key><value>' +
        this.getFileType() + '</value></entry></extendMetaData></data></RequestObject>'
      const jobFileMap = {}
      return getFileList(xmlParam).then(res => {
        let files = Array.from(res.data, p => {
          const fileName = p.fileName
          const fileType = p.fileType
          const fileCategory = p.extendMetaData.documentType || ''
          const jobNo = this.getFileJobNo(p.extendMetaData)
          const createdBy = p.extendMetaData.hasOwnProperty('createdBy') ? Number(p.extendMetaData['createdBy']) : 0
          const createDate = p.createDate
          const data = {
            jobNo: jobNo,
            documentId: p.id,
            fileName,
            fileType,
            fileSize: p.fileSize,
            jobType: fileCategory,
            fileVersion: p.fileVersion,
            createdBy,
            createDate
          }
          if (!jobFileMap.hasOwnProperty(jobNo)) {
            jobFileMap[jobNo] = 0
          }
          jobFileMap[jobNo] = jobFileMap[jobNo] + 1
          return data
        })
        files = files.filter(p => {
          if (this.creatorOption) {
            const { operator, value } = this.creatorOption
            if (operator === '=') {
              return p.createdBy === value
            }
            switch (operator) {
              case '=':
                return p.createdBy === value
              case '!=':
                return p.createdBy !== value
              case 'IN':
                return value.includes(p.createdBy)
              case 'NOT IN':
                return !value.includes(p.createdBy)
            }
          }
          if (this.createDateOption) {
            const { operator, value } = this.createDateOption
            if (operator === 'IS NULL') {
              return !p.createDate
            } else if (operator === 'IS NOT NULL') {
              return !!p.createDate
            } else if (operator === 'RANGE' || operator === 'DATE ITEM') {
              const items = value.split(',')
              let start = ''
              let end = ''
              for (const item of items) {
                if (item.startsWith('start=')) {
                  start = item.split('=')[1]
                  continue
                }
                if (item.startsWith('end=')) {
                  end = item.split('=')[1]
                  continue
                }
              }
              if (start) {
                if (end) {
                  return p.createDate >= start && p.createDate <= end
                } else {
                  return p.createDate >= start
                }
              } else {
                if (end) {
                  return p.createDate <= end
                }
              }
            }
          }
          return true
        })
        this.jobFileSizeMap = jobFileMap
        this.rowData = this.rowData.concat(files)
        this.getFilesSucceedHandler()
      })
    },
    getFileJobNo(extendMetaData) {
      for (const field in extendMetaData) {
        if (field === 'jobNo' || field === this.$t('CargoMsg.Cargo_BusinessNo')) {
          return extendMetaData[field]
        }
      }
    },
    getJobNoKey() {
      this.jobMap = {}
      let jobNo = ''
      for (const job of this.jobList) {
        if (jobNo.length > 0) {
          jobNo += ','
        }
        this.jobMap[job.jobNo] = job
        jobNo += job.jobNo
      }
      return '$in:' + jobNo
    },
    batchDowloadHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectAFileToDownloadOrSend'))
        return
      }
      const fileIds = Array.from(rows, p => p.documentId).join(',')
      const day = moment().format('YYYYMMDDHHmmss')
      const fileName = day + '.zip'
      // window.open(`${URL.common.compressFiles}?sessionId=${this.$store.getters.token}&fileIds=${fileIds}&fileName=${fileName}`)
      this.windowOpen(URL.common.downloadCompressFiles, fileIds, fileName)
    },
    windowOpen(url, fileIds, fileName) {
      this.submitForm.url = url
      const form = {}
      form.sessionId = this.$store.getters.token
      form.fileIds = fileIds
      form.fileName = fileName
      this.submitForm.formEntries = Object.entries(form)
      this.$nextTick(() => {
        let msg = '=============打印批量下载文件post参数=============\n'
        const tags = this.$refs.downloadForm.getElementsByTagName('input')
        for (const item of tags) {
          msg += `${item.name}: ${item.value}\n`
        }
        console.log(msg + '=============END=============')
        this.$refs.downloadForm.submit()
      })
    },
    toQuery() {
      this.rowData = []
      this.fullscreenLoading = getLoading()
      this.filter.branchId = this.$store.getters.currentOfficeId
      queryFileHistory(this.filter).then(res => {
        this.jobList = res.data
        this.getFileList()
        this.fullscreenLoading.close()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    batchDownload() {},
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    async onGridCellFocused(event) {
      // 等待gridApi被赋值
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
        if (this.gridApi && event.column) {
          this.gridApi.forEachNode(node => {
            if (node.rowIndex === event.rowIndex) {
              this.selectedJob = node.data
              this.manageAuditStatus = this.selectedJob.manageAuditStatus
            }
          })
        }
      })
    },
    // 选中 勾选框触发[获取选中行]
    onGridRowSelected(event) {
      if (event.node.isSelected() && event.data) {
        this.selectedJob = event.data
      }
      this.$logger.log('===onGridRowSelected====', this.selectedJob.jobNo + '_' + this.selectedJob.jobState)
    },
    resetSearch() {
      this.filter = PriceUtils.resetFilter(this.filter)
      this.fileCategoryLabel = ''
      this.filter.limit = 30
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.searchLob = 'allLob'
    },
    changeFileType(p) {
      if (p.fileCategory) {
        this.documentType = [...new Set(p.fileCategory.split(','))].join(',')
      } else {
        this.documentType = ''
      }
      if (p.fileCategoryLabel) {
        this.fileCategoryLabel = [...new Set(p.fileCategoryLabel.split(','))].join(',')
      } else {
        this.fileCategoryLabel = ''
      }
    },
    changeLob(p) {
      if (this.filter.lob !== p.value) {
        this.documentType = ''
        this.fileCategoryLabel = ''
        this.filter.lob = p.value
        this.searchLob = this.filter.lob || 'allLob'
      }
    },
    /* 文件列表 父级和子级组装*/
    getFilesSucceedHandler: function() {
      this.rowData = sortByMultiFieldAndOrder(this.rowData, { jobNo: 'asc', fileName: 'asc', fileVersion: 'desc', createDate: 'desc' })
      if (!this.rowData || this.rowData.length === 0) {
        this.total = 0
        return
      }
      const source = []
      let childFile
      const temp = {} // 用于标记该jobNo是否已经存在，创建父节点
      const tempFileName = {}
      let total = 0
      for (let i = 0; i < this.rowData.length; i++) {
        childFile = this.rowData[i]
        const jobNo = childFile.jobNo
        if (!temp.hasOwnProperty(jobNo)) {
          total++
          const job = this.getFather(jobNo)
          if (this.jobFileSizeMap[jobNo] === 1) {
            // 业务文件数量只有一条时，仅生成一条数据
            childFile = Object.assign(job, childFile)
            source.push(childFile)
            continue
          }
          temp[jobNo] = jobNo
          source.push(job)
        }
        const jobNoFileName = jobNo + childFile.fileName
        // 同个业务的文件名不重复显示
        if (tempFileName.hasOwnProperty(jobNoFileName)) {
          childFile.fileName = ''
        } else {
          tempFileName[jobNoFileName] = 0
        }
        childFile.path = jobNo + ',' + childFile.documentId
        childFile.hasParent = true
        childFile.parentId = jobNo
        childFile.jobNo = ''
        source.push(childFile)
      }
      this.total = total
      this.rowData = source
    },
    getFather(jobNo) {
      const job = this.jobMap[jobNo]
      return {
        jobNo: jobNo,
        customerId: job.customerId,
        mbl: job.mbl,
        carrierId: job.carrierId,
        ETD: job.etd,
        loadingPortCode: job.loadingPortCode,
        destinationPortCode: job.destinationPortCode,
        voyageFlight: job.voyageFlight,
        op: job.op,
        path: jobNo
      }
    },
    getFileType() {
      if (StrUtils.isEmpty(this.documentType)) {
        return ''
      }
      const oldAr = this.documentType.split(',')
      let regex = ''
      const lastIndex = oldAr.length - 1
      for (let i = 0; i < oldAr.length; i++) {
        regex += '\\b' + oldAr[i] + '\\b'
        if (oldAr.length > 1 && lastIndex !== i) {
          regex += '|'
        }
      }
      return ('$regex:' + regex)
    },
    // 简单查询
    toSimpleQuery(keyword) {
      let data
      if (typeof keyword !== 'undefined') {
        data = [
          new AdvancedSearchOption(null, 'job.JOB_NO', keyword, 'LIKE').formatObj2Json()
        ]
      }
      this.toAdvancedQuery(data)
    },
    // 高级查询
    async toAdvancedQuery(data) {
      const filter = this.filter
      if (typeof data !== 'undefined') {
        this.creatorOption = AdvancedSearchOption.removeOption('job.created_by', data)
        this.createDateOption = AdvancedSearchOption.removeOption('job.date_created', data)
        filter.conditions = data
        this.pageNum = 1
      }
      filter.branchId = this.$store.getters.currentOfficeId
      filter.pageNum = this.pageNum
      filter.pageSize = this.pageSize
      const loading = getLoading4Cxt(this)
      try {
        const res = await queryJobs(filter)
        this.rowData = []
        this.total = 0
        this.jobList = res.data.list
        await this.getFileList()
      } finally {
        loading.close()
      }
    }
  }
}
</script>

<style scoped>
</style>
